import Datepicker from "./Datepicker";
new Datepicker({
    scope: '[data-calendar]'
});
window.DatepickerClass = Datepicker;
